/* eslint-disable react-hooks/rules-of-hooks */
import styled from '@emotion/styled'
import { Button as MUIButton } from '@mui/material'
import { Typographies, useTypography, Colors, Shapes } from 'src/components/theme'
import { BOX_SHADOW } from 'src/components/theme/colors'

export const Button = styled(MUIButton)`
  // button colors are defined in muiPallete in components/theme/colors.tsx
  ${useTypography(Typographies.title2, true)}
  padding: ${Shapes.spacing[3]}px !important;
  text-transform: capitalize !important;
`

export const ToolbarButton = styled(MUIButton)`
  ${useTypography(Typographies.text2, true)}
  text-transform: none !important;
  color: ${Colors.textWhite} !important;
  background: ${Colors.blueDark} !important;
  padding-left: ${Shapes.spacing[5]}px !important;
  padding-right: ${Shapes.spacing[5]}px !important;

  &:hover {
    background: ${Colors.blueMedium};
  }

  &.Mui-disabled {
    background: ${Colors.bgLight} !important;
    color: ${Colors.textDisabled} !important;

    & svg {
      fill: ${Colors.textDisabled} !important;
    }
  }
`

export const ToolbarSecondaryButton = styled(MUIButton)`
  height: 30px !important;
  ${useTypography(Typographies.text2, true)}
  text-transform: none !important;
  color: ${Colors.textDark} !important;
  background: ${Colors.bgWhite} !important;
  border: 1px solid ${Colors.borderInput} !important;
  border-radius: ${Shapes.borderRadius}px !important;
  padding-left: ${Shapes.spacing[3]}px !important;
  padding-right: ${Shapes.spacing[3]}px !important;

  &:hover {
    background: ${Colors.bgWhite} !important;
    color: ${Colors.textBlack} !important;
  }

  &:hover svg {
    fill: ${Colors.textBlack} !important;
  }
`

export const ToolbarIconButton = styled.div<{ color: string }>`
  background-color: ${(props) => props.color};
  border-radius: ${Shapes.borderRadius}px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`

export const HeaderMainButton = styled(MUIButton)`
  ${useTypography(Typographies.text2, true)}
  text-transform: none !important;
  color: ${Colors.textWhite} !important;
  background: ${Colors.blueDark} !important;
  padding: ${Shapes.spacing[3]}px ${Shapes.spacing[3]}px !important;
  box-shadow: ${BOX_SHADOW} !important;
  margin-left: ${Shapes.spacing[2]}px !important;
  max-height: 45px !important;
  min-width: 45px !important;

  &:hover {
    background: ${Colors.blueMedium} !important;
  }

  &.Mui-disabled {
    background: ${Colors.bgLight} !important;
    color: ${Colors.textDisabled} !important;

    & svg {
      fill: ${Colors.textDisabled} !important;
    }
  }
`
